import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "start" }
const _hoisted_2 = { class: "col-12 col-lg-6" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"section-heading\"><h6 class=\"subtitle\">Active licenses</h6><h2 class=\"__title\"> Complete IP Database<br><span>and Accurate Geolocation Identification.</span></h2></div><div class=\"spacer py-4\"></div><div><p><strong style=\"color:#555;\">You don&#39;t have any active licenses.</strong><br> Start with choosing a database for your business. </p></div>", 3)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Get Started ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", null, [
        _createVNode(_component_a_button, {
          type: "primary",
          size: "large",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.router.push('/databases')))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}